<style>
  .UnSubmit {
    background-color: #ff9595 !important;
  }

  .Selected {
    background-color: #86e7d1 !important;
  }

  .MySecondDiv {
    width: 100%;
    transition: all 1.5s ease;
  }

  .MyFirstDiv {
    width: 0%;
    transition: all 1.5s ease;


  }

  /*
  .MyMainDiv:hover > .MyFirstDiv{
    width: 20%;
  }

  .MyMainDiv:hover > .MySecondDiv{
    width: 80%;
    padding-right: 5px;
  }
  */
</style>

<div class="col-xl-12 mb-30" [hidden]="Show_Lab_Form">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <div class="tab nav-border" style="position: relative;">
        <div class="d-block d-md-flex justify-content-between">
          <div class="d-block w-100">
            <h5 class="card-title border-0 pb-0">کارتابل کارشناس</h5>
          </div>
          <div class="d-block d-md-flex nav-tabs-custom">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#order" role="tab"
                  aria-controls="months" aria-selected="true">دستورکار آزمایشگاه</a>
              </li>
              <li class="nav-item">
                <a class="nav-link  show" id="months-tab" data-toggle="tab" href="#mission" role="tab"
                  aria-controls="months" aria-selected="true">دستورکار ماموریت</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
            <div class="row mb-30">

              <div class="col-md-12 mb-30" style="margin-top: 20px;">
                <div class="card card-statistics h-100" [hidden]="DataList_Kartable_Selected_DeviceBehfa.id>0">
                  <div class="card-body">

                    <div class="row">



                      <div class="col-md-3" (click)="Set__filter_DataList_Kartable(DataList_Kartable_wait_erja,1)">
                        <div class="card card-statistics h-100">
                          <div class="card-body" [ngClass]="{'Selected': DataList_Kartable_Type==1}">
                            <div class="clearfix">
                              <div class="float-left icon-box bg-danger rounded-circle">
                                <span class="text-white">
                                  <i class="fa fa-simplybuilt highlight-icon" aria-hidden="true"></i>
                                </span>
                              </div>
                              <div class="float-right text-right">
                                <p class="card-text text-dark"> منتظر انجام کار </p>
                                <h4>{{DataList_Kartable_wait_erja.length}}</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3"
                        (click)="Set__filter_DataList_Kartable(DataList_Kartable_wait_certificate,2)">
                        <div class="card card-statistics h-100">
                          <div class="card-body" [ngClass]="{'Selected': DataList_Kartable_Type==2}">
                            <div class="clearfix">
                              <div class="float-left icon-box bg-warning rounded-circle">
                                <span class="text-white">
                                  <i class="fa  fa-certificate highlight-icon" aria-hidden="true"></i>
                                </span>
                              </div>
                              <div class="float-right text-right">
                                <p class="card-text text-dark"> منتظر بارگذاری گواهی نامه</p>
                                <h4>{{DataList_Kartable_wait_certificate.length}}</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3"
                        (click)="Set__filter_DataList_Kartable(DataList_Kartable_wait_certificate_check,3)">
                        <div class="card card-statistics h-100">
                          <div class="card-body" [ngClass]="{'Selected': DataList_Kartable_Type==3}">
                            <div class="clearfix">
                              <div class="float-left icon-box bg-info rounded-circle">
                                <span class="text-white">
                                  <i class="fa fa-check-circle highlight-icon" aria-hidden="true"></i>
                                </span>
                              </div>
                              <div class="float-right text-right">
                                <p class="card-text text-dark"> منتظر پاسخ گواهی نامه</p>
                                <h4>{{DataList_Kartable_wait_certificate_check.length}}</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3" (click)="Set__filter_DataList_Kartable(DataList_Kartable_wait_upload,4)">
                        <div class="card card-statistics h-100">
                          <div class="card-body" [ngClass]="{'Selected': DataList_Kartable_Type==4}">
                            <div class="clearfix">
                              <div class="float-left icon-box bg-success rounded-circle">
                                <span class="text-white">
                                  <i class="fa fa-cloud-upload highlight-icon" aria-hidden="true"></i>
                                </span>
                              </div>
                              <div class="float-right text-right">
                                <p class="card-text text-dark"> منتظر خروج</p>
                                <h4>{{DataList_Kartable_wait_upload.length}}</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <br />
                    <br />

                    <div class="row">
                      <div class="form-group col-md-3">
                        <label for="exampleInputEmail1">نام مشتری</label>
                        <input [(ngModel)]="Filter_Customer_Order" (keyup)="Change_Filter_Order()"
                          name="Filter_Customer_Order" type="text" class="form-control"
                          placeholder="برای جستجوی ، اینجا تایپ کنید ...">
                      </div>
                      <div class="form-group col-md-3">
                        <label for="exampleInputEmail1">شماره رسید</label>
                        <input [(ngModel)]="Filter_RecieveCode_Order" (keyup)="Change_Filter_Order()"
                          name="Filter_RecieveCode_Order" type="text" class="form-control"
                          placeholder="برای جستجوی ، اینجا تایپ کنید ...">
                      </div>
                      <div class="form-group col-md-3">
                        <label for="exampleInputEmail1">شماره نامه</label>
                        <input [(ngModel)]="Filter_Code2_Order" (keyup)="Change_Filter_Order()"
                          name="Filter_Code2_Order" type="text" class="form-control"
                          placeholder="برای جستجوی ، اینجا تایپ کنید ...">
                      </div>
                      <div class="form-group col-md-3">
                        <label for="exampleInputEmail1">نام لاتین دستگاه</label>
                        <input [(ngModel)]="Filter_Devicename_Order" (keyup)="Change_Filter_Order()"
                          name="Filter_Devicename_Order" type="text" class="form-control"
                          placeholder="برای جستجوی ، اینجا تایپ کنید ...">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-md-6">
                        <button *ngIf="!Procssing_Kartable" type="button" (click)="ReadData_Kartable()"
                          class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> بروز رسانی
                          اطلاعات
                        </button>
                        <button *ngIf="!Procssing_Kartable" type="button" (click)="set_Show_Lab_Form()"
                          class="btn btn-warning" style="margin-left: 5px;"><i class="fa  fa-cloud-upload"></i> خروج از
                          آزمایشگاه </button>
                        <button *ngIf="Procssing_Kartable" type="button" class="btn btn-info" style="margin-left: 5px;">
                          لطفا صبر نمائید ... <i class="fa fa-spin fa-spinner"></i> </button>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6 mb-30" *ngFor="let item of DataList_Kartable
                      |filter:Filter_Customer_Order:'customer'
                      |filter:Filter_RecieveCode_Order:'recieveCode'
                      |filter:Filter_Code2_Order:'code2'
                      |filter:Filter_Devicename_Order:'devicename'
                      | paginate
                              : {
                                  id: 'DataList_Kartable',
                                  itemsPerPage: 20,
                                  currentPage: page_Kartable,
                                  totalItems: (DataList_Kartable
                                  |filter:Filter_Customer_Order:'customer'
                                  |filter:Filter_RecieveCode_Order:'recieveCode'
                                  |filter:Filter_Code2_Order:'code2'
                                  |filter:Filter_Devicename_Order:'devicename').length
                                }
                      ">

                        <div class="card h-100" [ngClass]="{'UnSubmit': item.controller.length>0}">
                          <div class="card-body">

                            <div class="row MyMainDiv" style="padding: 5px;">
                              <div class="MyFirstDiv">
                                <img src="{{BaseUrl}}{{item.username_img}}" title="{{item.username}}"
                                  style="width: 100%;height: 100%;" />
                              </div>
                              <div class="MySecondDiv">

                                <div style="float: right;">
                                  <p><span style="font-weight: 600;">دستگاه</span> {{item.controller.length}}
                                    '{{item.devicename}}' </p>
                                </div>
                                <div style="float: left;">
                                  <p><span style="font-weight: 600;">شماره نامه </span> '{{item.code2}}' </p>
                                </div>
                                <div style="clear: both;"></div>
                                <p style="cursor: pointer;text-decoration: underline;"
                                  (click)="openModal_Customer(templateCustomer,item)"><span
                                    style="font-weight: 600;">نام مشتری </span> '{{item.customer}}
                                  ({{item.customer_code}})' </p>
                                <p><span style="font-weight: 600;">آدرس گواهی نامه </span>
                                  '{{item.customer_address_certificate}}' </p>

                                <hr />
                                <div style="float: right;">
                                  <p><span style="font-weight: 600;">کد دستگاه </span> '{{item.code}}' </p>
                                  <p><span style="font-weight: 600;">سریال دستگاه</span> '{{item.serial}}' </p>
                                  <p><span style="font-weight: 600;">شماره رسید</span> '{{item.recieveCode}}' </p>
                                </div>
                                <div style="float: left;">
                                  <p><span style="font-weight: 600;">کارشناس</span> '{{item.expert_name}}' </p>
                                  <p><span style="font-weight: 600;">وضعیت</span> '{{item.status}}' </p>
                                  <p><span style="font-weight: 600;">تاریخ تحویل </span> '{{item.tarikhTahvi}}' </p>
                                </div>
                                <div style="clear: both;"></div>

                                <hr />

                                <span *ngIf="item.flowchartRequestDsc">
                                  <p><span style="font-weight: 600;">بازیابی گواهی نامه</span>
                                    '{{item.flowchartRequestDsc}}' </p>
                                  <hr />
                                </span>

                                <p><span style="font-weight: 600;">توضیحات تعرفه</span> '{{item.tariff_dsc}}' </p>

                                <hr />

                                <div *ngIf="item.hasRequestToExit>0">
                                  <p *ngIf="item.hasRequestToExit==2" style="font-weight: 600;color: blue;">درخواست خروج
                                    دستگاه ثبت شده است</p>
                                  <p *ngIf="item.hasRequestToExit==1" style="font-weight: 600;color: green;">درخواست
                                    خروج دستگاه تایید شده است</p>

                                  <hr />
                                </div>

                                <img *ngIf="item.Processing" src="assets/Loading.gif" style="width: 25px;" />

                                <div
                                  *ngIf="!item.Processing && item.status=='ارجاع' && !item.inlocation && item.typeItem==1">
                                  <!--
                                  <button type="button" (click)="OnSet_Calibration_DeviceBehfa(item,1)"
                                    class="btn btn-info">
                                    <i class="fa fa-building"></i> انتخاب تجهیز بهفا
                                  </button>
                                  -->

                                  <button (click)="openModalCalibrationDate(templateCalibrationDate,item)" type="button"
                                    class="btn btn-success" style="margin-right: 5px;">
                                    <i class="fa fa-check"></i> انجام کار در آزمایشگاه
                                  </button>

                                  <button (click)="openModal_LetterFile(templateLetterFile,item)" type="button"
                                    class="btn btn-warning" style="margin-right: 5px;">
                                    <i class="fa fa-file"></i> اطلاعات تکمیلی مشتری
                                  </button>

                                  <button *ngIf="item.hasRequestToExit==0 && !item.flowchartRequestDsc"
                                    (click)="openModal_Kartable(templateKartable,item)" style="margin-right: 5px;"
                                    type="button" class="btn btn-danger">
                                    <i class="fa fa-times-circle"></i> برگشت دستگاه
                                  </button>

                                  <button *ngIf="item.hasRequestToExit==0 && !item.flowchartRequestDsc"
                                    (click)="openModal_RequestToExit(templateRequestToExit,item)"
                                    style="margin-right: 5px;" type="button" class="btn btn-warning">
                                    <i class="fa fa-cloud-upload"></i> خروج دستگاه
                                  </button>

                                </div>

                                <div *ngIf="!item.Processing && item.status=='انجام کار' && item.typeItem==2">



                                  <div class="row">
                                    <div class="form-group col-md-12">



                                      <button *ngIf="item.src" [routerLink]="[item.src,{id:item.calibration_detail_id}]"
                                        style="margin-left: 10px;" type="button" class="btn btn-success"><i
                                          class="fa fa-file-code-o"></i> ثبت داده
                                      </button>

                                      <button *ngIf="!item.src" type="button" class="btn btn-success"
                                        style="margin-left: 10px;" (click)="openModal_upload(templateUpload,item)"><i
                                          class="fa fa-upload"></i>
                                        بارگذاری فایل گواهی نامه </button>
                                      <a *ngIf="item.filename && !item.src" target="_blank" style="margin-left: 10px;"
                                        href="{{BaseUrl}}File/Calibration/{{item.filename}}" class="btn btn-info"><i
                                          class="fa fa-eye"></i> مشاهده فایل گواهی نامه </a>

                                      <a style="margin-right: 10px;" *ngIf="item.certificate && item.src"
                                        style="margin-left: 10px;" target="_blank"
                                        href="{{BaseUrl}}{{item.certificate}}" class="btn btn-info"><i
                                          class="fa fa-eye"></i>
                                        مشاهده فایل گواهی نامه </a>

                                      <a style="margin-right: 10px;" *ngIf="item.filename && item.src"
                                        style="margin-left: 10px;" target="_blank" href="{{LabUrl}}{{item.filename}}"
                                        class="btn btn-info"><i class="fa fa-eye"></i>
                                        مشاهده فایل گواهی نامه </a>


                                      <button type="button" style="margin-left: 10px;"
                                        (click)="OnSet_Calibration_DeviceBehfa(item,0)" class="btn btn-info">
                                        <i class="fa fa-building"></i> تجهیز بهفا
                                      </button>

                                      <button *ngIf="item.hasRequestToExit==0 && !item.flowchartRequestDsc"
                                        (click)="openModal_RequestToExit(templateRequestToExit,item)"
                                        style="margin-right: 5px;" type="button" class="btn btn-warning">
                                        <i class="fa fa-cloud-upload"></i> خروج دستگاه
                                      </button>

                                      <button type="button" *ngIf="item.filename || item.certificate"
                                        (click)="SubmitExpertCalibrationDate(item)" style="margin-top: 10px;"
                                        class="btn btn-warning"><i class="fa fa-check"></i> ارسال برای بررسی گواهی نامه
                                      </button>

                                      <button type="button" *ngIf="item.controller.length>0"
                                        (click)="openModal_Controller(templateController,item)"
                                        style="margin-top: 10px;margin-right: 10px;" class="btn btn-danger"><i
                                          class="fa fa-file"></i> پیام های کنترل کننده </button>

                                    </div>
                                  </div>
                                </div>

                                <div *ngIf="!item.Processing && item.status=='بررسی برای ثبت خروج'">
                                  <h6 style="color: red;"> بررسی برای ثبت خروج </h6>
                                </div>

                                <div *ngIf="!item.Processing && item.status=='کنترل'">
                                  <h6 style="color: rgb(18 88 11);"> برای بررسی گواهی نامه ارسال شده است </h6>
                                </div>

                              </div>
                            </div>

                          </div>
                        </div>
                      </div>

                    </div>

                    <pagination-controls id="DataList_Kartable" nextLabel="بعدی" previousLabel="قبلی"
                      (pageChange)="page_Kartable = $event"></pagination-controls>


                  </div>
                </div>

                <app-CalibrationDeviceBehfa *ngIf="DataList_Kartable_Selected_DeviceBehfa.id>0"
                  (OnBack_CalibrationDeviceBehfa_Action)="OnSet_Back_Calibration_DeviceBehfa($event)"
                  [inner_Kartable_Order_Interface]="DataList_Kartable_Selected_DeviceBehfa"
                  [inner_Can_Add_Edit]="CanModify_Kartable_Selected_DeviceBehfa"
                  [inner_Persian_Date]="PersianToDayDate">

                </app-CalibrationDeviceBehfa>

              </div>



            </div>

          </div>

          <div class="tab-pane fade show" id="mission" role="tabpanel" aria-labelledby="months-tab">

            <br />
            <br />

            <app-CalibrationInPositionList
              [hidden]="Selected_Calibration_Id_Form!=-1 || Selected_Calibration_Id_Fund.id!=0 || Selected_Calibration_Id_Evaluate.id!=0 || Selected_Calibration_Id_Certificate.id!=0"
              (OnBack_Calibration_Action_Form)="OnSet_Back_Calibration_Id_Form($event)"
              (OnBack_Calibration_Action_Form_Schedule)="OnSet_Back_Calibration_Id_Form_Schedule($event)"
              (OnBack_Calibration_Action_Fund)="OnSet_Back_Calibration_Id_Fund($event)"
              (OnBack_Calibration_Action_Certificate)="OnSet_Back_Calibration_Id_Certificate($event)"
              (OnBack_Calibration_Action_Evaluate)="OnSet_Back_Calibration_Id_Evaluate($event)">

            </app-CalibrationInPositionList>

            <app-CalibrationInPositionForm *ngIf="Selected_Calibration_Id_Form>-1"
              (OnBack_Calibration_Action)="OnSet_Back_Calibration_Id_Form($event)"
              [Calibration_Form_Id]="Selected_Calibration_Id_Form"
              [LetterRequestSchduleCustomer_Id]="Selected_Calibration_Id_Form_Schedule">

            </app-CalibrationInPositionForm>

            <app-FundsLetterList *ngIf="Selected_Calibration_Id_Fund.id>0"
              (OnBack_Calibration_Action)="OnSet_Back_Calibration_Id_Fund_Back($event)"
              [inner_Calibration]="Selected_Calibration_Id_Fund">

            </app-FundsLetterList>

            <app-CalibrationEvaluateLetterForm *ngIf="Selected_Calibration_Id_Evaluate.id>0"
              (OnBack_Calibration_Action)="OnSet_Back_Calibration_Id_Evaluate_Back($event)"
              [inner_Calibration]="Selected_Calibration_Id_Evaluate">

            </app-CalibrationEvaluateLetterForm>


            <app-CalibrationInPositionCertificate *ngIf="Selected_Calibration_Id_Certificate.id>0"
              (OnBack_Calibration_Action)="OnSet_Back_Calibration_Id_Certificate_Back($event)"
              [inner_Calibration]="Selected_Calibration_Id_Certificate">

            </app-CalibrationInPositionCertificate>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<app-LabUploadDeviceForm *ngIf="Show_Lab_Form" [inner_UploadDevice_id]="1"
  (OnBack_UploadDevice_Action)="back_Show_Lab_Form($event)">

</app-LabUploadDeviceForm>

<ng-template #templateKartable>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> بازگشت دستگاه با کد/سریال
      {{DataList_Kartable_Selected.code}}/{{DataList_Kartable_Selected.serial}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Kartable.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input [(ngModel)]="OperationDsc_Kartable" name="OperationDsc_Kartable" type="text" class="form-control"
          placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="RequestExit()"> ارسال برای بررسی <i
        class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Kartable.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateRequestToExit>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> درخواست خروج دستگاه با کد/سریال
      {{DataList_Kartable_Selected_RequestToExit.code}}/{{DataList_Kartable_Selected_RequestToExit.serial}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_RequestToExit.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">توضیحات</label>
        <input [(ngModel)]="OperationDsc_RequestToExit" name="OperationDsc_RequestToExit" type="text"
          class="form-control" placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="RequestToExit()"> ارسال برای بررسی <i
        class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_RequestToExit.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCalibrationDate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">انجام کار در آزمایشگاه تجهیز '{{DataList_Kartable_Selected.devicename}}'</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_CalibrationDate.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">شرح اقدام اضافی </label>
        <input [(ngModel)]="CalibrationDate_Dsc" name="CalibrationDate_Dsc" type="text" class="form-control"
          placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="OnSubmitCalibrationDate()"> تایید <i
        class="fa fa-check"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_CalibrationDate.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateUpload>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> فایل گواهی نامه '{{Selected_DataList_Calibration.devicename}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_upload.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> انتخاب فایل </label>
          <input #file type="file" (change)="onFileSelected($event)" class="form-control">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> کد گواهی نامه </label>
          <input [(ngModel)]="certificate_user_code" name="certificate_user_code" type="text" class="form-control"
            placeholder="اینجا تایپ کنید ...">
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingUpload" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingUpload" type="button" (click)="upload(file.files)" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-upload"></i> آپلود فایل </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_upload.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateController>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> پیام های کنترل کننده '{{Selected_DataList_Calibration.devicename}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Controller.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>توضیحات</th>
              <th>کاربر</th>
              <th>تاریخ</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Controller_Data_List">
              <td>{{Controller_Data_List.indexOf(item)+1}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.title}}</td>
              <td>{{item.code}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Controller.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateLetterFile>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> فایل های پیوست شده </h4>
    <br />

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_LetterFile.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <h6 class="modal-title" style="float: left;"> شماره نامه مشتری '{{LetterFile_Data_Code}}' </h6>
      <h6 class="modal-title" style="float: right;"> تاریخ نامه مشتری '{{LetterFile_Data_Tarikh}}' </h6>
      <div style="clear: both;"></div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>فایل</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of LetterFile_Data_List">
              <td>{{LetterFile_Data_List.indexOf(item)+1}}</td>
              <td>
                <a target="_blank" href="{{BaseUrl}}File/Letter/{{item}}" class="btn btn-success"><i
                    class="fa fa-download"></i> مشاهده </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_LetterFile.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCustomer>

  <div class="modal-body">
    <app-CutomerView [inner_customer_id]="Selected_DataList_Customer.customer_id">

    </app-CutomerView>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Customer.hide()">بستن</button>
  </div>
</ng-template>